import { setupForDark } from '@theme';
import classNames from 'classnames';

export default function InputWarningMessage({ warning }: { warning: string }) {
  return (
    warning && (
      <div
        className={classNames(
          'flex flex-row items-center justify-start gap-xxs',
          'P5R',
          setupForDark('text-warning')
        )}
      >
        <div>{warning}</div>
      </div>
    )
  );
}
